import { useState, useCallback, useEffect } from 'react'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { toast } from '@sales-center/components'
import { IOpportunityExpectedClosingDateUpdate } from '../typings'
import { updateOpportunityExpectedClosingDate } from '../api'

export const useUpdateOpportunityExpectedClosingDate = () => {
  const dispatch = useAppDispatch()

  const [status, setStatus] = useState<'idle' | 'pending' | 'success' | 'fail'>(
    'idle',
  )

  const [toUpdate, setToUpdate] =
    useState<IOpportunityExpectedClosingDateUpdate>()

  const execute = useCallback(
    (update: IOpportunityExpectedClosingDateUpdate) => {
      if (status != 'pending') {
        setToUpdate(update)
      }
    },
    [status],
  )

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      if (toUpdate) {
        try {
          setStatus('pending')
          const result = await dispatch(
            updateOpportunityExpectedClosingDate(toUpdate),
          )

          if (mounted) {
            if (updateOpportunityExpectedClosingDate.fulfilled.match(result)) {
              setStatus('success')
            } else {
              setStatus('fail')
              toast.error(`Unable to update opportunity expected closing date.`)
            }
          }
        } catch (error) {
          if (mounted) {
            setStatus('fail')
            toast.error(error.Message)
          }
        } finally {
          setToUpdate(undefined)
          setStatus('idle')
        }
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch, toUpdate])

  return { status, execute }
}
